import { useState, useEffect, useRef } from 'react';
import keyBy from 'lodash/keyBy';
import isFunction from 'lodash/isFunction';
import { getResults } from '@Pages/RetroSynthesis/ProjectRoute/ReaxysExamplesSearchService';

// eslint-disable-next-line import/prefer-default-export
export const useResults = (resultItem) => {
  const [results, setResults] = useState(undefined);
  const requestRef = useRef();

  useEffect(() => {
    if (resultItem) {
      requestRef.current = getResults(resultItem, (items) => {
        setResults(keyBy(items, 'id'));
      });
    } else {
      setResults(undefined);
    }
  }, [resultItem]);

  // Clean-up on unmount - cancel results request
  useEffect(
    () => () => {
      if (requestRef.current && isFunction(requestRef.current.cancel)) {
        requestRef.current.cancel();
      }
    },
    []
  );

  return results;
};
